import { useCallback } from 'react'
import type { GridApi, GridReadyEvent } from 'ag-grid-community'

/**
 * Сохранение/восстановление состояния колонок AG Grid (ширина + порядок + сортировка)
 * в localStorage по аккаунту. Каждая таблица заказов передаёт свой базовый ключ;
 * к нему добавляется id пользователя — настройки персональные для каждого аккаунта.
 */
export function useOrderColState(storageKey: string, userId: string | undefined) {
  const key = userId ? `${storageKey}_${userId}` : ''

  const saveState = useCallback(
    (api: GridApi) => {
      if (!key) return
      try {
        localStorage.setItem(key, JSON.stringify(api.getColumnState()))
      } catch {
        /* ignore */
      }
    },
    [key],
  )

  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      if (!key) return
      const saved = localStorage.getItem(key)
      if (!saved) return
      try {
        params.api.applyColumnState({ state: JSON.parse(saved), applyOrder: true })
      } catch {
        /* ignore */
      }
    },
    [key],
  )

  return { saveState, onGridReady }
}
